import { Component, Input } from "@angular/core";

@Component({
    selector: "validation",
    templateUrl: "validation.component.html",
    styleUrls: ["validation.component.css"],
    standalone: false
})
export class ValidationComponent {
  @Input() ValidationList = [];
}
